import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const AboutOverview = () => {
  const { t } = useTranslation();
  
  return (
    <section className="section bg-gray-50">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 animate-slide-up">
            <h2 className="text-3xl font-bold mb-6 text-gray-900">{t('about.title')}</h2>
            <p className="text-lg text-primary-600 font-medium mb-4">{t('about.subtitle')}</p>
            <p className="text-gray-600 mb-6">{t('about.description')}</p>
            
            <h3 className="text-xl font-semibold mb-4 text-gray-800">{t('about.mission.title')}</h3>
            <p className="text-gray-600 mb-6">{t('about.mission.description')}</p>
            
            <ul className="mb-8 space-y-2">
              {t('about.values', { returnObjects: true }).map((value: string, index: number) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2 mt-1 bg-primary-100 text-primary-600 p-1 rounded-full">
                    <Check size={14} />
                  </span>
                  <span>{value}</span>
                </li>
              ))}
            </ul>
            
            <Link to="/about" className="btn btn-primary">
              {t('about.team.title')}
            </Link>
          </div>
          
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img 
                src="https://images.pexels.com/photos/3779705/pexels-photo-3779705.jpeg" 
                alt="Dental team" 
                className="rounded-lg shadow-xl w-full"
              />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg w-32 h-32 md:w-48 md:h-48 flex items-center justify-center">
                <div className="text-center">
                  <p className="text-2xl md:text-4xl font-bold text-primary-600">20+</p>
                  <p className="text-sm md:text-base font-medium text-gray-600">Years of Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOverview;